var applicationImage = {
    bindings : {

    },
    /**
     * @ngInject
     */
    controller : function ApplicationImageCtrl ($scope, $sce, $location, $timeout, userStore, flux, actions) {

        var ctrl = this;
        ctrl.messages = [];
        ctrl.step = 0;
        ctrl.totalSteps = [0,1];
        ctrl.photoUploaderModel = {};

        var message;
        var formData = {};

        function init () {
            ctrl.user = userStore.getUser();
            // console.log("init", ctrl.user);
            ctrl.photoUploaderModel.photo = ctrl.user.photo ? ctrl.user.photo : null;
        }

        function link () {
            $timeout(function() {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Vælg et godt billede af dig selv, som er passende 🤳'),
                    type: 'receive'
                });
            }, 500);
        }

        function onUserUpdated(data) {
            // console.log("onUserUpdated", userStore.getUser());

            if(angular.isDefined( userStore.getUser().photo )){
                if(userStore.getUser().photo != ctrl.photoUploaderModel.photo){
                    // console.log("SET PHOTO: ", userStore.getUser().photo);
                    ctrl.photoUploaderModel.photo = userStore.getUser().photo;
                }
            }

            if(!_.isEmpty(data)) {
                $timeout(function() {
                    $location.path('/din-ansoegning');
                }, 0);
            }   
        }

        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };

        ctrl.next = function next(){
            ctrl.step++;
            ctrl.messages = [];
        };

        ctrl.submitImage = function submitImage() {
            if(!_.isEmpty(ctrl.photoUploaderModel.name)) {
                formData.photo = ctrl.photoUploaderModel.base64type + "," + ctrl.photoUploaderModel.base64data;
                formData.orientation = ctrl.photoUploaderModel.orientation;
                flux.dispatch(actions.UPDATE_USER, formData);
            } else {
                if (ctrl.photoUploaderModel.photo !== null) {
                    $location.path( "/din-ansoegning#!" );
                } else {
                    ctrl.addMsg({
                        content: $sce.trustAsHtml('Ups du skal vælge et billede af dig selv'),
                        type: 'receive'
                    });
                    $("html, body").animate(
                        { scrollTop: 0 },
                        "slow"
                    );
                }
            }
        };

        ctrl.$onInit = init;
        ctrl.$postLink = link;

        $scope.$listenTo(userStore, ['user'], onUserUpdated);

    },
    templateUrl: './angular/components/application-image.component.html',
};